import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useEffect, useRef, useState } from 'react';
import { StorefrontListingCard } from '../../components/cards/StorefrontListingCard';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { AiSummaryCard } from './AiSummaryCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const COLUMN_WIDTH = 300;
export const GAP_TOKEN = '600';
export function ResultsGridWithSummary() {
  var _params$get, _data$result$cards, _data$result$aiReques, _data$result$aiAnswer;
  const {
    collectionId,
    collectionSlug,
    data,
    queryType
  } = useSearchResultsQuery();
  const mainGridRef = useRef(null);
  const mainGridResizeObserverRef = useRef(null);
  const [columnCount, setColumnCount] = useState(0);
  const [firstCardHeight, setFirstCardHeight] = useState(0);
  const params = useSearchParams();
  const pageNumber = parseInt((_params$get = params.get('page')) !== null && _params$get !== void 0 ? _params$get : '1', 10);
  const searchTerm = params.get('search');

  // get the pixel int from the Trellis token
  const columnGap = parseInt(useMapTokenPropsToCSS({
    gap: GAP_TOKEN
  }).gap, 10);
  useEffect(() => {
    if (!(data !== null && data !== void 0 && data.result.total)) return;
    const handleResize = () => {
      var _mainGridRef$current, _firstCard$clientHeig;
      const gridEl = (_mainGridRef$current = mainGridRef.current) === null || _mainGridRef$current === void 0 ? void 0 : _mainGridRef$current.firstElementChild;
      if (!gridEl) return;
      const newColumnCount = Math.floor((mainGridRef.current.clientWidth + columnGap) / (COLUMN_WIDTH + columnGap));

      // The first card is the second child of the CardGrid (after the AI card)
      const firstCard = gridEl.children[1];
      setFirstCardHeight((_firstCard$clientHeig = firstCard === null || firstCard === void 0 ? void 0 : firstCard.clientHeight) !== null && _firstCard$clientHeig !== void 0 ? _firstCard$clientHeig : 0);
      if (newColumnCount === columnCount) return;
      setColumnCount(newColumnCount);
    };
    if (mainGridRef.current) {
      mainGridResizeObserverRef.current = new ResizeObserver(handleResize);
      mainGridResizeObserverRef.current.observe(mainGridRef.current);
    }
    handleResize();
    return () => {
      if (mainGridResizeObserverRef.current) {
        mainGridResizeObserverRef.current.disconnect();
        mainGridResizeObserverRef.current = null;
      }
    };
  }, [data === null || data === void 0 ? void 0 : data.result.total, columnCount, columnGap]);
  const cards = (_data$result$cards = data === null || data === void 0 ? void 0 : data.result.cards) !== null && _data$result$cards !== void 0 ? _data$result$cards : [];
  return /*#__PURE__*/_jsx("div", {
    ref: mainGridRef,
    children: /*#__PURE__*/_jsxs(CardGrid, {
      columnSize: COLUMN_WIDTH,
      gap: GAP_TOKEN,
      children: [/*#__PURE__*/_jsx(AiSummaryCard, {
        aiRequestId: (_data$result$aiReques = data === null || data === void 0 ? void 0 : data.result.aiRequestId) !== null && _data$result$aiReques !== void 0 ? _data$result$aiReques : '',
        gridIsSingleColumn: columnCount === 1,
        maxHeight: firstCardHeight || 300,
        preexistingAnswer: (_data$result$aiAnswer = data === null || data === void 0 ? void 0 : data.result.aiAnswer) !== null && _data$result$aiAnswer !== void 0 ? _data$result$aiAnswer : ''
      }), cards.map((card, index) => /*#__PURE__*/_jsx(StorefrontListingCard, {
        collectionId: collectionId,
        collectionSlug: collectionSlug,
        listing: card,
        pageNumber: pageNumber,
        queryType: queryType,
        resultCount: cards.length,
        resultIndex: index + 1,
        searchTerm: searchTerm
      }, card.listingId))]
    })
  });
}